'use strict';

import protobuf from 'protobufjs';

const pbMessages = {};
export const packetQuotesSubscribe = 101;
export const packetQuotesSubscribeOk = 102;
export const packetQuotesUnsubscribe = 103;
export const packetQuotesUnsubscribeOk = 104;
export const packetQuotesNew = 105;

function load () {
    const protoJson = {
        'nested': {
            'quotes': {
                'nested': {
                    'ListOfSymbols': {
                        'fields': {
                            'Symbols': {
                                'rule': 'repeated',
                                'type': 'string',
                                'id': 1
                            }
                        }
                    },
                    'QuoteTradeItem': {
                        'fields': {
                            'Symbol': {
                                'type': 'string',
                                'id': 1
                            },
                            'Rate': {
                                'type': 'uint32',
                                'id': 2
                            },
                            'Spread': {
                                'type': 'uint32',
                                'id': 3
                            },
                            'Time': {
                                'type': 'int32',
                                'id': 4
                            },
                            'Flags': {
                                'type': 'uint32',
                                'id': 5
                            },
                            'Number': {
                                'type': 'uint64',
                                'id': 6
                            }
                        }
                    },
                    'Quotes': {
                        'fields': {
                            'QuotesTrade': {
                                'rule': 'repeated',
                                'type': 'QuoteTradeItem',
                                'id': 1
                            }
                        }
                    },
                    'QuotesWithBuffers': {
                        'fields': {
                            'QuotesTrade': {
                                'rule': 'repeated',
                                'type': 'bytes',
                                'id': 1
                            }
                        }
                    }
                }
            }
        }
    };
    return protobuf.Root.fromJSON(protoJson);
}

class ProtoBufCodec {
    constructor () {
        let proto = load();
        pbMessages[packetQuotesSubscribe] = proto.lookup('quotes.ListOfSymbols');
        pbMessages[packetQuotesUnsubscribe] = proto.lookup('quotes.ListOfSymbols');
        pbMessages[packetQuotesNew] = proto.lookup('quotes.Quotes');
    }

    decode (buf) {
        if (buf.byteLength < 4) {
            throw new Error('Packet is too small');
        }
        const dw = new DataView(buf);
        const result = {
            type: dw.getUint16(0, true),
            id: dw.getUint16(2, true),
            message: null
        };
        if (buf.byteLength > 4 && pbMessages[result.type]) {
            result.message = pbMessages[result.type].decode(new Uint8Array(buf, 4));
        }
        return result;
    }

    encode ({type, id, data}) {
        let pbBuffer, resultBuffer, dw, i;
        if (!pbMessages[type]) {
            throw new Error('Unknown packet type: ' + type);
        }
        pbBuffer = pbMessages[type].encode(data).finish();
        resultBuffer = new ArrayBuffer(pbBuffer.length + 4);
        dw = new DataView(resultBuffer);
        dw.setUint16(0, type, true);
        dw.setUint16(2, id, true);
        for (i = 0; i < pbBuffer.length; i++) {
            dw.setUint8(i + 4, pbBuffer[i]);
        }
        return resultBuffer;
    }
}

export const codec = new ProtoBufCodec();



// WEBPACK FOOTER //
// ./src/utils/protobuf.js